module.exports = __webpack_public_path__ + "2d9d2c135b16248db7c4054e4bb1675f.svg";